<template>
  <div class="reference-action-controls px-4 py-3">
    <screening-action-controls
      v-if="reviewStage === ReviewStage.SCREENING"
      :review="review"
      :reference="reference"
      :current-researcher="currentResearcher"
      :disabled="disabled"
      @create-screening-vote="$emit('create-screening-vote', $event)"
      @change-screening-vote="$emit('change-screening-vote', $event)"
      @revoke-screening-vote="$emit('revoke-screening-vote', $event)"
      @resolve-screening-conflict="
        $emit('resolve-screening-conflict', $event)
      "
      @change-screening-outcome="
        $emit('change-screening-outcome', $event)
      "
      @back="reviewStageOverride = null"
    />
    <full-text-review-action-controls
      v-else-if="reviewStage === ReviewStage.FULL_TEXT_REVIEW"
      :review="review"
      :reference="reference"
      :current-review-member="currentReviewMember"
      :disabled="disabled"
      @create-full-text-review-vote="
        $emit('create-full-text-review-vote', $event)
      "
      @change-full-text-review-vote="
        $emit('change-full-text-review-vote', $event)
      "
      @revoke-full-text-review-vote="
        $emit('revoke-full-text-review-vote', $event)
      "
      @resolve-full-text-review-conflict="
        $emit('resolve-full-text-review-conflict', $event)
      "
      @change-full-text-review-outcome="
        $emit('change-full-text-review-outcome', $event)
      "
      @back="reviewStageOverride = null"
      @change-previous-stage="
        reviewStageOverride = ReviewStage.SCREENING
      "
    />
    <extraction-action-controls
      v-else
      :review="review"
      :reference="reference"
      :current-researcher="currentResearcher"
      :disabled="disabled"
      @change-previous-stage="
        reviewStageOverride = ReviewStage.FULL_TEXT_REVIEW
      "
      @extract="$emit('extract', $event)"
      @extraction-consensus-review="
        $emit('extraction-consensus-review', $event)
      "
    />
  </div>
</template>

<script>
import ScreeningActionControls from './ScreeningActionControls';
import FullTextReviewActionControls from './FullTextReviewActionControls';
import ExtractionActionControls from './ExtractionActionControls';
import { Review, Reference, ReviewMember } from '@/models';
import { ReviewStage } from '@/enums';

export default {
  name: 'ReferenceActionControls',
  components: {
    ScreeningActionControls,
    FullTextReviewActionControls,
    ExtractionActionControls,
  },
  props: {
    review: {
      type: Review,
      required: true,
    },
    reference: {
      type: Reference,
      required: true,
    },
    currentReviewMember: {
      type: ReviewMember,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    'create-screening-vote',
    'change-screening-vote',
    'revoke-screening-vote',
    'resolve-screening-conflict',
    'change-screening-outcome',
    'create-full-text-review-vote',
    'change-full-text-review-vote',
    'revoke-full-text-review-vote',
    'resolve-full-text-review-conflict',
    'change-full-text-review-outcome',
    'extract',
    'extraction-consensus-review',
    'change-previous-stage',
    'back',
  ],
  data: () => ({
    reviewStageOverride: null,
  }),
  computed: {
    ReviewStage() {
      return ReviewStage;
    },
    reviewStage() {
      return (
        this.reviewStageOverride || this.reference.getReviewStage()
      );
    },
    currentResearcher() {
      return this.currentReviewMember.researcher;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~vuetify/src/styles/styles.sass';

.reference-action-controls {
  background-color: map-get($grey, 'lighten-5');
  border-top: 1px solid map-get($grey, 'lighten-2');
}
</style>
